import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

import { useQuery } from '../../utils/hooks/useQuery';
import { getImagePath } from '../../utils';
import { translate } from '../Translate';

const ErrorComponent = () => {

  const [isOpen, setIsOpen] = useState(false);

  const history = useHistory();
  const toggleOpen = () => setIsOpen((prev) => !prev)

  const { client, code } = useParams()
  const query = useQuery()

  const logoImg = getImagePath('logo.png', client);
  const intl = useIntl();

  const handleGoBack = () => {
    const returnUrl = query.get('return_url')

    if (returnUrl) {
      window.location.replace(returnUrl)
    } else {
      history.goBack()
    }
  }

  document.title = "Motorplay"

  return (
    <div className="App Cloudpay">
      <div className='Error'>
        <img src={logoImg} alt="logo" className='Error_image_logo' />
        <h1 className='Error_title'>
          <FormattedMessage
            id={`ErrorComponent.errors.${code}`}
            defaultMessage={translate(intl, 'ERRORS.defaultMessage')}
          />
        </h1>
        <div>
          <div className='Error_details_container'>
            <p className='Error_details'>
              <FormattedMessage id="ErrorComponent.details" />
            </p>
            <button className='Error_details_button' onClick={toggleOpen}>
              {isOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
          </div>
          {isOpen &&
            <div className='Error_details_content'>
              <p><FormattedMessage id="ErrorComponent.description" values={{ code }} /></p>
              <p>{query.get('message')}</p>
            </div>
          }
        </div>
        <button className='Error_back' onClick={handleGoBack}>Volver</button>
      </div>
    </div>
  );
};

export default ErrorComponent;
